const HeroContent = ({
  eyebrow = "Global IT Consulting & Staffing",
  title,
  titleAccent,
  lede,
  primary = { href: "#contact", label: "Start a Project" },
  secondary = { href: "#services", label: "Explore Services" },
  stats = [],
}) => (
  <div className="hero__content reveal">
    <span className="eyebrow">{eyebrow}</span>
    <h1 className="hero__title">
      {title} <span className="hero__title-grad">{titleAccent}</span>.
    </h1>
    <p className="hero__lede">{lede}</p>

    <div className="hero__cta">
      <a href={primary.href} className="btn btn-primary">
        {primary.label} <i className="fa-solid fa-arrow-right" />
      </a>
      <a href={secondary.href} className="btn btn-ghost">
        {secondary.label}
      </a>
    </div>

    {stats.length > 0 && (
      <ul className="hero__meta">
        {stats.map((s) => (
          <li key={s.label}>
            <strong>{s.value}</strong>
            <span>{s.label}</span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default HeroContent;
